const offset = 500;
const scrollUp = document.querySelector('.scroll-up');

if(scrollUp) {
  const getTop = () => window.pageYOffset || document.documentElement.scrollTop;

  window.addEventListener('scroll', () => {
    if (getTop() > offset) {
      scrollUp.classList.add('active');
    } else {
      scrollUp.classList.remove('active');
    }
  });

  scrollUp.addEventListener('click', () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  });
}
